import { Typography } from "@suraasa/placebo-ui"
import { ReactNode } from "react"

type Props = {
  icon: ReactNode
  title: string
  subtitle: string
  gradient: string
}

const FeatureCard = ({ icon, title, subtitle, gradient }: Props) => {
  return (
    <div
      className="flex flex-col rounded-xl p-2"
      style={{ background: gradient }}
    >
      {icon}
      <Typography className="my-1 text-[14px] font-semibold leading-[130%] tracking-normal">
        {title}
      </Typography>
      <Typography variant="smallBody" className="text-onSurface-600">
        {subtitle}
      </Typography>
    </div>
  )
}

export default FeatureCard
